export const workflowSubprocessTimeoutMs = 10 * 60 * 1_000;
